module.exports = __webpack_public_path__ + "media/images/home/focus_logo1-22635adfdbbdb50a59a246f7cb05c618.png";